import { BaseWebComponentView } from '../../../../../framework/BaseWebComponentView';
import { ReconfigureAgentType } from '../types';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { GzRadioGroupWebComponent, GzRadioWebComponent } from '../../../../../ui/gzRadio';
import { translateFn } from '../../../../../utils/translator.helper';
import { TemplateState } from '../../../../../types/common/types';
import { GzTextWebComponent } from '../../../../../ui/gzText';

export class ReconfigureAgentTypeFormView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;

    $reconfigureAgentTypeFormField: GzFormFieldWebComponent<GzRadioGroupWebComponent, string | number>;
    $reconfigureAgentTypesGroup: GzRadioGroupWebComponent;
    $reconfigureAgentAddModules: GzRadioWebComponent;
    $reconfigureAgentAddModulesDescription: GzTextWebComponent;

    $reconfigureAgentRemoveModules: GzRadioWebComponent;
    $reconfigureAgentRemoveModulesDescription: GzTextWebComponent;

    $reconfigureAgentMatchModules: GzRadioWebComponent;
    $reconfigureAgentMatchModulesDescription: GzTextWebComponent;
  };

  getDomElements(): void {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $reconfigureAgentTypeFormField: this.shadow.querySelector('#reconfigure-agent-operations-form-field'),
      $reconfigureAgentTypesGroup: this.shadow.querySelector('#reconfigure-agent-operations-group'),

      $reconfigureAgentAddModules: this.shadow.querySelector('#reconfigure-agent-add-modules'),
      $reconfigureAgentAddModulesDescription: this.shadow.querySelector('#reconfigure-agent-add-modules-description'),

      $reconfigureAgentRemoveModules: this.shadow.querySelector('#reconfigure-agent-remove-modules'),
      $reconfigureAgentRemoveModulesDescription: this.shadow.querySelector(
        '#reconfigure-agent-remove-modules-description'
      ),

      $reconfigureAgentMatchModules: this.shadow.querySelector('#reconfigure-agent-match-modules'),
      $reconfigureAgentMatchModulesDescription: this.shadow.querySelector(
        '#reconfigure-agent-match-modules-description'
      ),
    };

    this.getTranslations();
    this.setTranslatedStrings();
  }

  buildSuccessView(): void {
    this.dom.$reconfigureAgentAddModules.value = ReconfigureAgentType.Add;
    this.dom.$reconfigureAgentRemoveModules.value = ReconfigureAgentType.Remove;
    this.dom.$reconfigureAgentMatchModules.value = ReconfigureAgentType.Match;

    this.dom.$reconfigureAgentTypeFormField.Input.setFormValue(ReconfigureAgentType.Add);
  }

  getTranslations(): void {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  setTranslatedStrings(): void {
    this.dom.$reconfigureAgentAddModules.label = translateFn('Add');
    this.dom.$reconfigureAgentAddModulesDescription.innerText = translateFn(
      'Add selected modules to the agent installed on target endpoints.'
    );
    this.dom.$reconfigureAgentAddModulesDescription.innerText +=
      '\n' +
      translateFn(
        'Reconfiguration will only impact endpoints running the same operation mode as the one selected from the drop-down.'
      );

    this.dom.$reconfigureAgentRemoveModules.label = translateFn('Remove');
    this.dom.$reconfigureAgentRemoveModulesDescription.innerText = translateFn(
      'Remove selected modules from the agent installed on target endpoints.'
    );
    this.dom.$reconfigureAgentRemoveModulesDescription.innerText +=
      '\n' +
      translateFn(
        'Reconfiguration will only impact endpoints running the same operation mode as the one selected from the drop-down.'
      );

    this.dom.$reconfigureAgentMatchModules.label = translateFn('Match list');
    this.dom.$reconfigureAgentMatchModulesDescription.innerText = translateFn(
      'Update the agent on your endpoints to an identical module setup.'
    );
    this.dom.$reconfigureAgentMatchModulesDescription.innerText +=
      '\n' +
      translateFn('Reconfiguration will activate the operation mode selected from the drop-down on all endpoints.');
  }

  buildErrorView(error: Error): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }
}
